import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { SMSHttpClient } from "../helpers/http-client";
import { Observable } from "rxjs";
import { IClient } from "../interface/client";
import { Globals } from "../shared/globals";
import { IUser } from "../interface/user";
import { error } from "console";

@Injectable({
  providedIn: "root"
})
export class UserService {
  constructor(
    private httpClient: SMSHttpClient,
    public objGlobals: Globals
  ) {}

  getUserLayers(clientId, userId) {
    return this.httpClient.get(environment.getClientlist + "/" + clientId + "/" + environment.getUserlist + "/" + userId + "/" + environment.getLayerAccess);
  }

  getUserInfo(clientId, userId) {
    return this.httpClient.get(environment.getClientlist + "/" + clientId + "/" + environment.getUserlist + "/" + userId);
  }

  // Client List Services
  getClientList() {
    return this.httpClient.get(environment.getClientlist);
  }

  getRoleslist(): any {
    return this.httpClient.get(environment.getRoleslist);
  }

  getClient(clientId: number) :Observable<IClient> {
    return this.httpClient.get(environment.getClient + "/" + clientId);
  }

  // Start User Base Services
  getUserListByClient(ClientId) {
    return this.httpClient.get(environment.getClientlist + "/" + ClientId + "/" + environment.getUserlist);
  }

  getUserNamesByClient(ClientId) {
    return this.httpClient.get(environment.getClientlist + "/" + ClientId + "/" + environment.getUserlist);
  }

  postUserDataByClient(ClientId, obj) {
    return this.httpClient.post(environment.getSignup + "/" + ClientId, obj);
  }

  deleteUserDataByClient(clientId, UserId) {
    return this.httpClient.delete(environment.getClientlist + "/" + clientId + "/" + environment.getUserlist + "/" + UserId);
  }

  UpdateUserDataByClient(ClientId, UserId, obj) {
    return this.httpClient.post(environment.getUpdateUser + "/" + ClientId + "/" + environment.getUser + "/" + UserId, obj);
  }
  // End User Base Services

  // Start LayerList Base Services
  getUserLayerAccess(clientId, userId) {
    //console.log("getting layers");
    return this.httpClient.get(environment.getClientlist + "/" + clientId + "/" + environment.getUserlist + "/" + userId + "/" + environment.getLayerAccess);
  }

  userAccountUnlock(userId) {
    // Added by Abhilash Jira Id:-57 on 10/11/2021
    return this.httpClient.post(environment.AccountUnlockPost + "?UserId=" + userId, null);
  }

  postUserLayerAccess(ClientId, UserId, obj) {
    return this.httpClient.post(environment.getClientlist + "/" + ClientId + "/" + environment.getUserlist + "/" + UserId + "/" + environment.getLayerAccess, obj);
  }

  RemoveUserLayerAccess(clientId, UserId, LayerId) {
    return this.httpClient.delete(environment.getClientlist + "/" + clientId + "/" + environment.getUserlist + "/" + UserId + "/" + environment.getLayerAccess + "/" + LayerId);
  }
  // End LayerList Base Services

  // Start Region Base Services
  getUserRegionAccess(clientId, userId) {
    console.log("getting regions");
    return this.httpClient.get(environment.getClientlist + "/" + clientId + "/" + environment.getUserlist + "/" + userId + "/" + environment.getRegionAccess);
  }

  postUserRegionAccess(ClientId, UserId, obj) {
    return this.httpClient.post(environment.getClientlist + "/" + ClientId + "/" + environment.getUserlist + "/" + UserId + "/" + environment.getRegionAccess, obj);
  }

  RemoveUserRegionAccess(ClientId, UserId, RegionName, RegionLevel) {
    return this.httpClient.delete(
      environment.getClientlist + "/" + ClientId + "/" + environment.getUserlist + "/" + UserId + "/" + environment.getRegionAccess + "?RegionName=" + RegionName + "&RegionLevel=" + RegionLevel
    );
  }
  // End Region Base Services

  getUserRolePermissionInfo(userId, clientId) {
    return this.httpClient.get(environment.getClientlist + "/" + clientId + "/" + environment.getUserlist + "/" + userId + "/UserPermission");  //jcc swtiched from RolePermission Nov 2025. 
  }

  //sortedWorkerList(clientId, activeRegions, activeLayerId, callback){
  getWorkerList(clientId: number, forLayerIds: number[] = []){
    //'Worker' = user with Data Editor priviledge in current context

    const workersObservable = new Observable((workersObserver) => {

      this.getUserListByClient(clientId).subscribe(function (users: any) {

        //filter on Role  -- for non-admin, list is the 'Limited' version which zeros out the RoleID property
        // const includeRoleIds = this.objGlobals.userRoles.filter( r => r.roleName != "Readonly" && r.roleName != "3MAdmin" && r.roleName != "Integrator").map( r => r.roleId);
        // let workerList = users.filter( u => includeRoleIds.includes(u.roleId));
        let workerList = users;

        //filter to Data Editor for any regions that overlaps current
        workerList = workerList.filter(user => {
          let de = false;
          user.regions.forEach( r => {
            if (r.accessPrivilege === "Data Editor" && this.objGlobals.regionOverlaps['level'+r.regionLevel].includes(r.regionName)) {
              de = true;
            }
          });
          return de;
        });

        //filter to Data Editor for visible, and optionally specified, asset classes
        workerList = workerList.filter( u => {
          let de = false;
          u.layers.forEach( lyr => {
            if (  lyr.accessPrivilege == "Data Editor" && 
                  this.objGlobals.visibleLayerIds.includes(parseInt(lyr.gisLayerId,10)) && 
                  (forLayerIds.length == 0 || forLayerIds.includes(parseInt(lyr.gisLayerId,10)))
            ) {
              de = true;
              }
          });
          return de;
        });

        // // TESTS w/reversed logic
        // let filtered = users.filter( u => includeRoleIds.includes(u.roleId) == false)
        // console.log('filtered out by role: ');
        // console.log(filtered);
        // if (activeRegions){
        //   filtered = users.filter(user => {
        //     let match = false;
        //     user.regions.forEach( r => {
        //       if (r.accessPrivilege === "Data Editor" && r.regionName === activeRegions['region'+r.regionLevel]) {
        //         match = true;
        //       }
        //     });
        //     return !match;
        //   });
        // }
        // console.log('no DE for current region: ');
        // console.log(filtered);
        // filtered = users.filter( u => {
        //   let de = false;
        //   u.layers.forEach( lyr => {
        //     if (lyr.accessPrivilege == "Data Editor" 
        //       && this.objGlobals.visibleLayerIds.includes(parseInt(lyr.gisLayerId))
        //       && (forLayerIds.length == 0 || forLayerIds.includes(lyr.gisLayerId))
        //     ) {
        //       de = true;
        //   });
        //   return !de;
        // });
        // console.log('filtered no DE for layerId or layer not visible');
        // console.log(filtered);

        workerList.sort((a: any, b: any) => {
            const x = a.displayName.toLowerCase();
            const y = b.displayName.toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        });

        workerList.unshift({username: '', displayName:''});

        workersObserver.next(workerList);        
      }.bind(this))
    })
    return workersObservable
  }

  isDataEditorForRoleRegionAndLayer(user: IUser, layerId: number): boolean {
    try {
      const roleEditor: boolean = user.rolePermissions.roleName != "Readonly";
      const regionEditor: boolean = user.selectedRegion.accessPrivilege === "Data Editor";  
      const layerEditor: boolean = user.assignedAssetClasses.filter( lyr => {
          if ( lyr.layerId === layerId && lyr.accessPrivilege === "Data Editor") {
            return lyr;
          }
        }).length > 0;
      return roleEditor && regionEditor && layerEditor;  
    }
    catch (error) {
      return false;
    };
    
  }

}
